import { transition } from './helpers/common';
import EventHandler from './EventHandler';
import NavMobile from './NavMobile';
import StickyHeader from './StickyHeader';
import NavDesktopMenu from './NavDesktopMenu';
import Forms from './Forms';
import Layout from './Layout';
import LiveSearch from './LiveSearch';
import { SearchForm } from './SearchForm';
import jQuery from 'jquery';
export default class StaticHeader {
    constructor(section) {
        this.el = section.el;
        this.settings = section.data.settings;
        this.postMessage = section.postMessage;
        this.headerSearch = null;
        this.scripts = document.querySelector('[data-scripts]');
        this.menuToggle = this.el.querySelector('[data-menu-toggle]');
        this.cartCount = this.el.querySelector('[data-header-cart-count]');
        this.searchField = this.el.querySelector('[data-live-search]');
        this.siteNavigation = this.el.querySelector('[data-site-navigation]');
        this.desktopNavigation = this.siteNavigation.querySelector('ul.navmenu-depth-1');
        this.headerTools = this.siteNavigation.querySelector('[data-header-actions]');
        this.stickyHeader = new StickyHeader({
            header: this.el,
            menuToggle: this.menuToggle,
            postMessage: this.postMessage,
        }, this.settings);
        this.navMobile = new NavMobile({
            el: this.el,
            toggleOpen: this.menuToggle,
        });
        const navmenus = document.querySelectorAll('.sb-navmenu--menus > [data-navmenu]');
        if (navmenus.length) {
            this.navDesktop = [];
            for (let navmenu of navmenus) {
                this.navDesktop.push(new NavDesktopMenu(navmenu));
            }
        }
        else {
            const navmenu = document.querySelector('.site-navigation > [data-navmenu]');
            this.navDesktop = new NavDesktopMenu(navmenu);
        }
        this.forms = new Forms(this.el);
        this.events = new EventHandler();
        if (this.settings.live_search.enable) {
            jQuery(this.scripts.dataset.shopifyApiUrl, () => {
                this.headerSearch = new LiveSearch({
                    el: this.searchField,
                    header: this.el,
                }, Object.assign(Object.assign({}, this.settings.live_search), { use_dimmer: true }));
                this.mobileSearchButtonEl = section.el.querySelector('[data-mobile-search-button]');
                if (this.mobileSearchButtonEl) {
                    const disableAnimations = 'reduceAnimations' in document.body.dataset;
                    this.mobileSearchButtonAnimation = transition({
                        el: this.mobileSearchButtonEl,
                        state: 'visible',
                    });
                    this.events.register(this.mobileSearchButtonEl, 'click', (e) => {
                        var _a;
                        e.stopPropagation();
                        (_a = this.headerSearch) === null || _a === void 0 ? void 0 : _a.open();
                        this.mobileSearchButtonAnimation.animateTo('hidden', {
                            force: disableAnimations,
                        });
                    });
                    this.headerSearch.onClose = () => {
                        this.mobileSearchButtonAnimation.animateTo('visible', {
                            force: disableAnimations,
                        });
                        this.mobileSearchButtonEl.focus();
                    };
                }
            });
        }
        else {
            this.headerSearch = new SearchForm(this.searchField);
        }
        this.events.register(window, 'cartcount:update', (event) => {
            this.cartCount.dataset.headerCartCount = event.detail.item_count;
            if (event.detail.item_count > 0) {
                this.cartCount.classList.add('visible');
            }
            else {
                this.cartCount.classList.remove('visible');
            }
        });
    }
    onSectionSelect() {
        this.stickyHeader.openNavigation();
    }
    onSectionDeselect() {
        this._closeAllNavigation();
    }
    onSectionUnload() {
        var _a;
        this.stickyHeader.unload();
        this.navMobile.unload();
        const navmenus = document.querySelectorAll('.sb-navmenu--menus > [data-navmenu]');
        if (navmenus.length) {
            for (let navDesktop of this.navDesktop) {
                navDesktop.unload();
            }
        }
        else {
            this.navDesktop.unload();
        }
        this.forms.unload();
        (_a = this.headerSearch) === null || _a === void 0 ? void 0 : _a.unload();
        this.events.unregisterAll();
    }
    onSectionMessage(name, data) {
        if (name === 'nav:close-all' && Layout.isGreaterThanBreakpoint('M')) {
            this._closeAllNavigation();
        }
        /*
          This event gets dispatched from StaticCollection.js > _fireEvent()
          It should fire when the collection page's utility bar becomes sticky
          the box-shadow on the header should be removed and placed on the
          utility bar instead.
        */
        if (name === 'collection-page:collection-utils-sticky-change') {
            this._handleStickyChange(data);
        }
    }
    onSectionBlockSelect(block) {
        if (!Layout.isGreaterThanBreakpoint('M')) {
            return;
        }
        this.stickyHeader.openNavigation(() => {
            const navmenus = document.querySelectorAll('.sb-navmenu--menus > [data-navmenu]');
            if (navmenus.length) {
                for (let navDesktop of this.navDesktop) {
                    navDesktop.selectBlock(block.id);
                }
            }
            else {
                this.navDesktop.selectBlock(block.id);
            }
        });
    }
    onSectionBlockDeselect() {
        this._closeAllNavigation();
    }
    _closeAllNavigation() {
        const navmenus = document.querySelectorAll('.sb-navmenu--menus > [data-navmenu]');
        if (navmenus.length) {
            for (let navDesktop of this.navDesktop) {
                navDesktop.closeAllMenus();
            }
        }
        else {
            this.navDesktop.closeAllMenus();
        }
    }
    /*
      Remove the box-shadow when the collection page's utility bar has become sticky.
      This only needs to happen if the sticky header is enabled and if the header
      background colour is the same as the body background colour. Otherwise, no box-shadow is shown.
    */
    _handleStickyChange(data) {
        if (!this.settings.sticky_header || !this.settings.has_box_shadow)
            return;
        const { stuck, target } = data;
        this.el.classList.toggle('site-header-wrapper--no-shadow', stuck);
    }
}
